<template>
  <transition name="cmp-slide">
    <div v-if="visivel" class="cmp-card">
      <p class="cmp-card-eyebrow">
        {{ enviarIndividual ? "Envio" : "Passo 4 de " + totalPassos }}
      </p>
      <h3 class="cmp-card-title">Pronto para enviar</h3>

      <!-- Resumo -->
      <div class="cmp-resumo" v-if="!enviarIndividual">
        <div class="cmp-resumo-item" v-if="!isTeste && titulo">
          <span class="cmp-resumo-label">Campanha</span>
          <span class="cmp-resumo-value">{{ titulo }}</span>
        </div>
        <div class="cmp-resumo-item" v-if="isTeste">
          <span class="cmp-resumo-label">Modo</span>
          <span class="cmp-resumo-value">🧪 Teste</span>
        </div>
        <div class="cmp-resumo-item">
          <span class="cmp-resumo-label">Canal</span>
          <span class="cmp-resumo-value">{{
            canal === "whatsapp" ? "💬 WhatsApp" : "🔔 Push"
          }}</span>
        </div>
        <div class="cmp-resumo-item" v-if="canal === 'whatsapp' && template">
          <span class="cmp-resumo-label">Template</span>
          <span class="cmp-resumo-value">{{ template }}</span>
        </div>
        <div
          class="cmp-resumo-item"
          v-if="!isTeste && !enviarParaTodos && numClientes > 0"
        >
          <span class="cmp-resumo-label">Destinatários</span>
          <span class="cmp-resumo-value text-orange"
            >{{ numClientes }} clientes</span
          >
        </div>
        <div class="cmp-resumo-item" v-if="!isTeste && enviarParaTodos">
          <span class="cmp-resumo-label">Destinatários</span>
          <span class="cmp-resumo-value">Todos os contactos</span>
        </div>
      </div>

      <!-- Intervalo do evento -->
      <div v-if="!isTeste" class="mt-3">
        <label class="cmp-label">Intervalo do evento (opcional)</label>
        <b-row>
          <b-col xl="6">
            <label class="cmp-label-small">Data de início</label>
            <b-form-datepicker
              :value="dataEvento && dataEvento.inicio"
              :min="new Date().toISOString().split('T')[0]"
              locale="pt-PT"
              placeholder="Início"
              @input="emitirDiaEvento('inicio', $event)"
            />
          </b-col>
          <b-col xl="6">
            <label class="cmp-label-small">Data de fim</label>
            <b-form-datepicker
              :value="dataEvento && dataEvento.fim"
              :min="
                (dataEvento && dataEvento.inicio) ||
                new Date().toISOString().split('T')[0]
              "
              locale="pt-PT"
              placeholder="Fim"
              @input="emitirDiaEvento('fim', $event)"
            />
          </b-col>
        </b-row>
        <!-- Preview do intervalo selecionado -->
        <div
          v-if="dataEvento && dataEvento.inicio"
          class="cmp-intervalo-preview mt-2"
        >
          <span>📅 {{ fmtDate(dataEvento.inicio) }}</span>
          <span v-if="dataEvento.fim"> → {{ fmtDate(dataEvento.fim) }}</span>
        </div>
      </div>

      <div class="cmp-actions mt-3">
        <base-button type="neutral" size="md" @click="$emit('recuar')">
          <i class="ni ni-bold-left mr-1"></i> Voltar
        </base-button>
        <base-button
          v-if="!isTeste"
          type="neutral"
          size="md"
          @click="$emit('toggle-agendar')"
        >
          <i class="ni ni-calendar-grid-58 mr-1"></i>
          {{ agendar ? "Cancelar" : "Agendar envio" }}
        </base-button>
        <base-button type="primary" size="md" @click="$emit('enviar')">
          <i class="ni ni-send mr-1"></i> Enviar agora
        </base-button>
      </div>

      <!-- Agendamento -->
      <div v-if="agendar" class="cmp-agendar-block mt-3">
        <p class="cmp-card-eyebrow mb-3">Agendamento</p>
        <b-row>
          <b-col xl="6">
            <label class="cmp-label">Data</label>
            <b-form-datepicker
              :value="dataAgendada"
              :min="new Date().toISOString().split('T')[0]"
              locale="pt-PT"
              class="mb-2"
              @input="$emit('update:dataAgendada', $event)"
            />
          </b-col>
          <b-col xl="6">
            <label class="cmp-label">Hora</label>
            <b-form-timepicker
              :value="horaAgendada"
              locale="pt-PT"
              class="mb-2"
              @input="$emit('update:horaAgendada', $event)"
            />
          </b-col>
        </b-row>
        <base-button type="primary" size="md" @click="$emit('agendar')">
          Confirmar agendamento
        </base-button>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "CampanhaPasso4",
    props: {
      visivel: { type: Boolean, default: false },
      enviarIndividual: { type: Boolean, default: false },
      isTeste: { type: Boolean, default: false },
      totalPassos: { type: Number, default: 4 },
      titulo: { type: String, default: "" },
      canal: { type: String, default: "" },
      template: { default: null },
      enviarParaTodos: { type: Boolean, default: false },
      numClientes: { type: Number, default: 0 },
      // dataEvento agora é { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
      dataEvento: { default: null },
      agendar: { type: Boolean, default: false },
      dataAgendada: { default: null },
      horaAgendada: { default: null },
    },
    methods: {
      emitirDiaEvento(campo, valor) {
        const atual = this.dataEvento || { inicio: null, fim: null };
        this.$emit("update:dataEvento", { ...atual, [campo]: valor });
      },
      fmtDate(d) {
        if (!d) return "—";
        return d.slice(0, 10).split("-").reverse().join("/");
      },
    },
  };
</script>

<style scoped>
  .cmp-label-small {
    display: block;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #adb5bd;
    margin-bottom: 6px;
    margin-top: 4px;
  }
  .cmp-intervalo-preview {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 130, 93, 0.08);
    border: 1px solid rgba(255, 130, 93, 0.2);
    border-radius: 20px;
    padding: 5px 12px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #ff825d;
  }
</style>
